import React, { memo, useEffect, useMemo, useState } from "react";
import { campaignTotalsLabels, dateFormatter } from "@revbox/localization";
import { cookiesKeyNames } from "@revbox/common-fe";
import { isValidPeriod } from "@revbox/helpers-fe";
import { getPeriodCampaignTotals } from "../../../services/micro";
import { Card, Placeholder, Col, Row } from "react-bootstrap";
import { useCookiesContext } from "../../../contexts/CookiesContext";
import { decrypt } from "../../../helpers/crypto";
import { useEurUsdRate } from "../../../hooks/useEurUsdRate";
import { OverlayContainer } from "../../../services/currency/RenderTooltip";

const HTR_PUBLISHER_ID = 67

function daysUntilNextMonth(language) {
  const today = new Date();
  const year = today.getFullYear();
  const nextMonth = today.getMonth() + 1;

  const firstDayOfNextMonth = new Date(year, nextMonth, 1);
  const formatedDate = dateFormatter(firstDayOfNextMonth, language)

  today.setHours(0, 0, 0, 0);
  firstDayOfNextMonth.setHours(0, 0, 0, 0);

  const diffTime = firstDayOfNextMonth.getTime() - today.getTime();
  return [formatedDate, Math.ceil(diffTime / (1000 * 60 * 60 * 24))]
}

const computeCustomDate = (card, language, value, rate) => {
  if (card.label === 'Current Period Spend') {
    return dateFormatter(String(card.description), language)
  }

  if (card.label === 'Current Outstanding Balance') {
    return daysUntilNextMonth(language)
  }

  if (card.label === 'Current PPC Credits') {
    return [value, rate]
  }

  return card.description
}

function AdvertiserTotals({ currentPeriod, previousPeriod, campaignId, isIframe, publisherId }) {
  const { getLanguageAbbr, updateCookiesProperty } = useCookiesContext();
  const language = getLanguageAbbr();
  const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const token = urlParams.get("token");
  const [response, setResponse] = useState([]);
  const { rate } = useEurUsdRate();

  useEffect(() => {
    if (isValidPeriod(currentPeriod) && isValidPeriod(previousPeriod)) {
      getPeriodCampaignTotals(currentPeriod, previousPeriod, campaignId, token).then(
        (response) => {
          if (response && response.length > 0) {
            setResponse(response);
          } else {
            setResponse([]);
          }
        }
      );
    } else {
      console.error("currentPeriod or previousPeriod is not set");
    }
  }, [currentPeriod, previousPeriod, campaignId, token]);

  useEffect(() => {
    if (isIframe && urlParams) {
      const advId = urlParams.get('advId')
      if (!advId) {
        return
      }
      const decryptedAdvId = decrypt(advId)
      updateCookiesProperty(cookiesKeyNames.skinMode, "light", decryptedAdvId)
    }
  }, [isIframe, urlParams])
  // todo: credits spend for htr instead of balance (BE work)
  if (response) {
    return (
      <React.Fragment>
        {response.map((card, index) => {
          const { title, description } = campaignTotalsLabels[language][card.label];
          const customDate = computeCustomDate(card, language, response[0].value, rate);

          return (
            <Col md={HTR_PUBLISHER_ID == publisherId ? "4" : "6"} xl="4" key={index}>
              <Card className="card-one iframe-card-background">
                <Card.Body>
                  <Row>
                    <Col xs="12">
                      <OverlayContainer amount={card.value} rate={rate}>
                        <h3 className={`${card.class} fw-bold card-value mb-1`} style={{ width: 'max-content' }}>
                          {card.value}
                        </h3>
                      </OverlayContainer>
                      <label className="card-title fw-medium text-dark mb-1">
                        {title}
                      </label>
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer style={{ height: '60px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <span className="d-block text-muted fs-11 ff-secondary lh-4">
                    {description(customDate)}
                  </span>
                </Card.Footer>
              </Card>
            </Col>
          )
        })}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment style={{ color: "var(--bs-body-color)" }}>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder style={{ height: 200, width: "100%" }} />
        </Placeholder>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder style={{ height: 200, width: "100%" }} />
        </Placeholder>
      </React.Fragment>
    );
  }
}

export default memo(AdvertiserTotals);